import React, { useCallback, useEffect, useState } from "react";

import { FormProvider } from "react-hook-form";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import Loading from "wrappers/Loading";

import Page from "components/Page";

import { PASOS_BREADCRUMBS } from "utils/constants";

import EmisionFooterBarButtons from "components/Polizas/EmisionFooterBarButtons";
import BreadCrumbSegukids from "components/BreadCrumbMex/BreadCrumbSegukids";
import useCustomForm from "hooks/useCustomForm";
import useBuscarMunicipios from "hooks/useBuscarMunicipios";
import useBuscarColonias from "hooks/useBuscarColonias";
import { useNavbarContext } from "contexts/NavbarContext";
import { ApiKeyFetch } from "api/fetchers/apiKey";
import { urlCatalogoPagador, urlGuardarPagador } from "constants/urls";
import { isArray, mapArrayDropdownOptions } from "utils/funciones";
import DynamicForm from "components/DynamicForm";
import MessageMia from "./MessageMia";
import SiNoInputContainer from "components/InputsMex/containers/SiNoInputContainer";
import { TextInput } from "components/InputsMex/inputs";
import { SimpleCheckBox } from "components/InputsMex/SimpleInputs";
import useCustomToast from "hooks/useCustomToasts";
import ModalContratante from "components/ModalMex/ModalContratante";

const PagadorKids = ({ qParams, history }) => {
  const { idPoliza, codProducto } = qParams;
  const methods = useCustomForm({ mode: "onChange" });
  const [catalogo, setCatalogo] = useState(null);
  const [loading, setLoading] = useState(true);

  const municipiosHook = useBuscarMunicipios();
  const { setMunicipios } = municipiosHook;
  const coloniasHook = useBuscarColonias();
  const { setColonias } = coloniasHook;

  const [routes, setRoutes] = useState({});

  const [idCotizacion, setidCotizacion] = useState();
  
  const [nameCotizador, setnameCotizador] = useState();

  const { setProductoActivo } = useNavbarContext();

  const { addSuccessToast, addWarningToast } = useCustomToast();

 
  const onClickAtras = () => {
    //history.push(`/kids/pago?idCotizacion=${idCotizacion}`);
    history.push(`/facturacion/tipo-persona?idPoliza=${idPoliza}&ramo=SKT`);
  };
  const init = useCallback(async () => {
    setLoading(true);
    setProductoActivo(codProducto);

    const Body = {
      polCodigo: idPoliza,
      prodCodigo: codProducto,
      pasoRevContratante: "obtenerPagador",
      pasoCatContratante: "catalogoContratante",
      formulario: "contratante",
      formCodigo: "formPagadorSeguKids",
      datosCotizador: {
        formCodigo: "formPagadorSeguKids",
      },
    };

    const res = await ApiKeyFetch.instance().post(urlCatalogoPagador, Body);
    let nombre = res.data.catalogo.sources.lead.usuNombre.split(" ")[0];
    setidCotizacion(res.data.catalogo.idCotizacion);
    setnameCotizador(nombre);

    if (res?.transaccion && res?.data) {
      const { municipios, colonias, catalogo } = res?.data;
      if (!catalogo?.camposAdicionales?.permitirEmitir) {
        addWarningToast("No se puede emitir esta póliza", {
          autoDismiss: false,
        });
      }

      if (catalogo?.DatosContratanteAsegurado) {
        methods.reset({
          ...catalogo.DatosContratanteAsegurado,
        });
        if (isArray(municipios)) {
          setMunicipios(municipios?.map(mapArrayDropdownOptions));
        }

        if (isArray(colonias)) {
          setColonias(colonias?.map(mapArrayDropdownOptions));
        }
      }
      setRoutes(catalogo?.pasosRedireccionamiento);
      setCatalogo(catalogo);
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  const valueDatosContratante = methods.watch("pagador");
  const tutor = methods.watch("PadreMadreTutor");
  const guardarInformacion = async (data, guardarDatos) => {
    try {
      if (tutor === false) {
        addWarningToast(
          "Si el contratante no es el Padre, Madre o Tutor, no es posible proceder con la compra."
        );
      } else {
        setLoading(true);
        const Data = {
          idPoliza: idPoliza,
          datosPagador: data,
          save: guardarDatos,
        };
        const res = await ApiKeyFetch.instance().post(urlGuardarPagador, Data);       
        if (res.transaccion) {
          if (valueDatosContratante && guardarDatos === false) {
            history.push(`/kids/asegurado?idPoliza=${idPoliza}`);
          } else if (guardarDatos === false) {
            history.push(
              `/kids/contratante?idPoliza=${idPoliza}&codProducto=SKT`
            );
          } else {
            addSuccessToast("Haz guardado tu información con éxito.");
          }
        } else {
          addWarningToast(
            "Ha ocurrido un problema al momento de guardar el contratante"
          );
        }
        setLoading(false);
        init();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onSubmit = async (data) => {
    await guardarInformacion(data, false);
  };

  const onGuardar = async () => {
    const isValid = await methods.trigger("tipoPersona");
    if (isValid) {
      const data = methods.getValues();
      await guardarInformacion(data, true);
    } else {
      addWarningToast("Debe seleccionar un tipo de persona");
    }
  };

  const onSubmitError = () => {
    addWarningToast("Rellene el formulario correctamente");
  };
  const messageRobot = (
    <React.Fragment>
      <div>1. Pagador (puede ser una persona diferente al contrante).</div>
      <div>2. Contratante/beneficiario (Obligatorio Padre, Madre o Tutor).</div>
    </React.Fragment>
  );
  return (
    <Loading loading={loading}>
      {catalogo?.DatosContratanteAsegurado && (
                <ModalContratante catalogo={catalogo}/>
            )} 
      <div className="cr-content">
        <Page styles={{ marginBottom: "0px", minHeight: "100%" }}>
          <BreadCrumbSegukids
            {...PASOS_BREADCRUMBS[PRODUCTOS.SEGUKIDS]
              .breadCrumbPasosSegukids[4]}
            pasos={PASOS_BREADCRUMBS[PRODUCTOS.SEGUKIDS]?.pasosContratante}
            showImg={false}
            showImgTitle={true}
            subtitleClassnames={"col-md-12 p-0"}
          />
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <MessageMia
                  textMessage={
                    "¡Hola " +
                    nameCotizador +
                    "!, Por favor ayúdanos con la información del:"
                  }
                  content={messageRobot}
                  showContent={true}
                ></MessageMia>
              </div>
            </div>
          </div>
          <FormProvider {...methods}>
            <form className="mb-0">
              <div className="container">
                <div className="border mb-5 mx-1">
                  <div class="row ">
                    <div class="col-md-12 mb-0">
                      {catalogo?.validaciones && (
                        <DynamicForm
                          {...catalogo?.validaciones}
                          resources={catalogo}
                          containerFormColsClassNames={"col-md-12"}
                          containerFormPadMarClassNames={"mb-0"}
                          containerFormClassName={
                            "dynamic__form__container__sin__border"
                          }
                        />
                      )}
                    </div>
                  </div>
                  <div className="row mb-5 justify-content-center">
                    <div class="col-md-12">
                      <EmisionFooterBarButtons
                        showAtras={true}
                        onClickAtras={onClickAtras}
                        onClickGuardar={onGuardar}
                        onClickContinuar={methods.handleSubmit(
                          onSubmit,
                          onSubmitError
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </FormProvider>
        </Page>
      </div>
    </Loading>
  );
};

export default PagadorKids;
